<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ProjectDetail from '@/components/ProjectDetail.vue';

const route = useRoute();

// Compute the numeric projectId by converting the route param to a number
const projectId = computed(() => {
  const id = route.params.id as string;
  const parsedId = Number(id);
  if (isNaN(parsedId)) {
    throw new Error('Invalid project ID');
  }
  return parsedId;
});
</script>

<template>
  <div>
    <!-- Include the ProjectDetail component -->
    <ProjectDetail :id="projectId" />
  </div>
</template>

<style scoped></style>
